// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { canWrite } from '../../../../../../common/permissions/permissionUtil';

// Actions
import { finishEditingCurrentElement } from '../../../../../element/selection/selectionActions';

// Components
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { Sheet } from '../../../../../mobile/structural/sheet/Sheet';
import MobileElementContextMenu from '../../../../contextMenu/MobileElementContextMenu';

import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';

const MobileContextMenuTool = (props: any) => {
    const dispatch = useDispatch();
    const sheetProps = useSheet(SheetId.ContextMenuTool);
    const isEditable = canWrite(props.permissions);

    const handleToolClick = () => {
        if (!isEditable) return;

        dispatch(finishEditingCurrentElement());
        sheetProps.openSheet();
    };

    return (
        <>
            <ToolbarTool {...props} name={props.name} onClick={handleToolClick}>
                <Icon name="toolbar-context-menu" />
            </ToolbarTool>
            <Sheet defaultSnapPoint={'0.6max'} {...sheetProps}>
                <Sheet.Overlay />
                <Sheet.Panel>
                    <Sheet.Content>
                        <MobileElementContextMenu {...props} isEditable={isEditable} />
                    </Sheet.Content>
                </Sheet.Panel>
            </Sheet>
        </>
    );
};

MobileContextMenuTool.propTypes = {
    name: PropTypes.string,
    isActive: PropTypes.bool,
    permissions: PropTypes.number.isRequired,
};

export default MobileContextMenuTool;
